import '../../../css/Timesheets.css';

import React, { useMemo } from 'react';

import Icon from 'react-icons-kit';
import { close as closeIcon } from 'react-icons-kit/ikons/close';
import { plus } from 'react-icons-kit/ikons/plus';
import { refresh } from 'react-icons-kit/ionicons/refresh';
import { ic_mode_edit } from 'react-icons-kit/md/ic_mode_edit';
import Modal from 'react-modal';

import { getAllEmployees } from '../../../requests/EmployeeRequests';
import MinuteTable from '../../components/MinuteTable';
import Select from '../../components/Select.js';

try {
    Modal.setAppElement('#root');
} catch {}
const EmployeeResourcesList = ({
    title,
    onClick,
    history,
    payrollItems,
    createNewLabel,
    createNewPath,
    activateEmployee,
    deactivateEmployee,
    currentUserId,
    manageAccount,
}) => {
    const columns = useMemo(
        () => [
            {
                accessor: 'first_name',
                Header: 'First Name',
            },
            {
                accessor: 'last_name',
                Header: 'Last Name',
            },
            {
                accessor: 'email',
                Header: 'Email',
            },
            {
                accessor: 'reference_number',
                Header: 'Employee Number',
            },
            {
                Header: 'Status',
                id: 'status',
                accessor: () => 'Status',
                Cell: tableProps => (
                    <td className="tsStatusCell">
                        {tableProps.row.original.hidden === 'No' && (
                            <span
                                className={
                                    currentUserId === tableProps.row.original.id
                                        ? 'tsStatus tsStatusDisabled'
                                        : 'tsStatus tsStatusApproved'
                                }
                                onClick={() =>
                                    onToggleApproved(tableProps.row.original, currentUserId)
                                }
                            >
                                {isUpdatingStatus ? 'Updating...' : 'Active'}
                            </span>
                        )}
                        {tableProps.row.original.hidden === 'Yes' && (
                            <span
                                className={
                                    currentUserId === tableProps.row.original.id
                                        ? 'tsStatus tsStatusDisabled'
                                        : 'tsStatus tsStatusPending'
                                }
                                onClick={() =>
                                    onToggleApproved(tableProps.row.original, currentUserId)
                                }
                            >
                                {isUpdatingStatus ? 'Updating...' : 'Inactive'}
                            </span>
                        )}
                    </td>
                ),
            },
            {
                Header: 'Actions',
                id: 'actions',
                accessor: () => 'Actions',

                Cell: tableProps => (
                    <Icon
                        onClick={() => onClick(tableProps.row.original, currentUserId)}
                        icon={ic_mode_edit}
                        className="tableIcon asAccountUserIcon"
                        size={22}
                        data-tip="Edit Permissions"
                        style={{
                            color: checkBoxColor(
                                currentUserId === tableProps.row.original.id && !manageAccount
                            ),
                        }}
                    />
                ),
            },
        ],
        []
    );

    const statusFilters = [
        { name: 'All EMPLOYEES', id: 'all' },
        { name: 'ACTIVE', id: 'active' },
        { name: 'INACTIVE', id: 'inactive' },
    ];
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [refreshTable, setRefreshTable] = React.useState(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = React.useState(0);
    const [filter, setFilter] = React.useState('active');
    const [resetTable, setResetTable] = React.useState(false);
    const [isUpdatingStatus, setIsUpdatingStatus] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const fetchIdRef = React.useRef(0);
    const sortIdRef = React.useRef(0);

    const fetchData = React.useCallback(({ sortBy, pageSize, pageIndex, filter }) => {
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        setRefreshTable(false);
        setResetTable(false);
        setTimeout(() => {
            if (fetchId === fetchIdRef.current) {
                let paramsObject = {
                    current_page: pageIndex + 1,
                    per_page: pageSize,
                    filter: filter,
                };
                Promise.all([getAllEmployees(paramsObject)]).then(response => {
                    let json = response[0];
                    let employeesList = json.employessList;
                    employeesList.forEach(employee => {
                        employee['payRollItemsNames'] = getPayRollList(employee.payroll_item_ids);
                    });
                    if (sortBy.length > 0) {
                        const sortId = ++sortIdRef.current;
                        if (sortId === sortIdRef.current) {
                            let sorted = employeesList;
                            sorted.sort((a, b) => {
                                for (let i = 0; i < sortBy.length; ++i) {
                                    if (a[sortBy[i].id] > b[sortBy[i].id])
                                        return sortBy[i].desc ? -1 : 1;
                                    if (a[sortBy[i].id] < b[sortBy[i].id])
                                        return sortBy[i].desc ? 1 : -1;
                                }
                                return 0;
                            });
                            setData(employeesList);
                            setPageCount(Math.ceil(json.meta.total / pageSize));
                            setLoading(false);
                        }
                    } else {
                        setData(employeesList);
                        setPageCount(Math.ceil(json.meta.total / pageSize));
                        setLoading(false);
                    }
                });
            }
        }, 1000);
    }, []);

    function checkBoxColor(value) {
        if (value) {
            return 'gray';
        } else {
            return '#008fd7';
        }
    }

    function handleFilterChanged(value) {
        setFilter(value);
        setResetTable(true);
    }
    function closeModal() {
        setIsModalOpen(false);
    }
    function getPayRollList(payRollIds) {
        let payRolls = [];
        if (payRollIds != null) {
            payrollItems.forEach(val => {
                if (payRollIds.split(',').includes(val.id)) {
                    payRolls.push(val.name);
                }
            });
        }
        return payRolls.join(',');
    }

    function onToggleApproved(employee, currentEmployee_id) {
        if (currentEmployee_id !== employee.id) {
            if (employee.hidden === 'No') {
                setSelectedEmployeeId(employee.id);
                setIsModalOpen(true);
                //deactivateEmployee(employee.id);
            } else {
                setIsUpdatingStatus(true);
                activateEmployee(employee.id);
                setIsUpdatingStatus(false);
                setRefreshTable(true);
            }
        }
    }

    function inactiveUser(keepUser = false) {
        setIsUpdatingStatus(true);
        deactivateEmployee(selectedEmployeeId, { keep_user: keepUser });
        setIsUpdatingStatus(false);
        setRefreshTable(true);
        closeModal();
    }

    return (
        <div>
            <h3 className="cardHeading">
                {title}
                <div className="bodyHeader filters">
                    <div className="" style={{ fontWeight: 'lighter' }}>
                        <Select
                            toggleStyle="button"
                            className="multiselectFilter"
                            options={statusFilters}
                            value={filter}
                            defaultValue="active"
                            onChange={handleFilterChanged}
                        />
                    </div>

                    <div className="">
                        <button
                            className="secondaryButton"
                            style={{ height: '35px' }}
                            onClick={() => history.push(createNewPath)}
                        >
                            <Icon className="icon" icon={plus} size={20} />
                            {createNewLabel}
                        </button>
                    </div>
                    <div className="headerActions">
                        <button
                            className="secondaryButton"
                            style={{ height: '35px' }}
                            onClick={() => setRefreshTable(true)}
                        >
                            <Icon className="icon" icon={refresh} size={20} />
                        </button>
                    </div>
                </div>
            </h3>
            <Modal
                closeTimeoutMS={400}
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Inactive user"
                className="modalContainer resourceModal"
            >
                <div className="modalHeader">
                    <h2>Deactivate Employee</h2>
                    <div className="modalOptions">
                        <Icon
                            className="modalIcon"
                            size={32}
                            icon={closeIcon}
                            onClick={closeModal}
                        />
                    </div>
                </div>
                <div className="modalContent helpModalContent">
                    <div className="sectionAnswer">
                        Are you sure you want to deactivate this employee?
                    </div>
                    <div className="sectionAnswer">
                        Do you want to keep or delete the user associated with this employee?
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div className="sectionButton">
                            <button className="destructiveButton" onClick={() => inactiveUser()}>
                                Delete User
                            </button>
                        </div>
                        <div className="sectionButton">
                            <button className="primaryButton" onClick={() => inactiveUser(true)}>
                                Keep User
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            <div className="cardContainer asSection">
                <MinuteTable
                    columns={columns}
                    data={data}
                    fetchData={fetchData}
                    loading={loading}
                    pageCount={pageCount}
                    filter={filter}
                    refresh={refreshTable}
                    resetTable={resetTable}
                />
            </div>
        </div>
    );
};

export default EmployeeResourcesList;
